module.exports = __webpack_public_path__ + "static/media/arrow-from-top.1f1be024.svg";